import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import DeliveryPackage from '../entities/delivery-package'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
interface DeliveryPackageState extends ListState<DeliveryPackage> {
}
class DeliveryPackageModule extends ListModule<DeliveryPackageState, any, DeliveryPackage>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<DeliveryPackage>(),
        loading: false
    }
    actions = {
        async getAll(context: ActionContext<DeliveryPackageState, any>, payload: any) {
            context.state.loading = true;
            const {data:{result} }= await Ajax.get('/api/services/app/DeliveryPackage/GetAll', { params: payload.data });
            context.state.loading = false;
            const page = result as PageResult<DeliveryPackage>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        }
    };
    mutations = {
        setCurrentPage(state: DeliveryPackageState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: DeliveryPackageState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}
const sdeliveryPackageModule = new DeliveryPackageModule();
export default sdeliveryPackageModule;